import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FEATURE_NAME, NotificationState} from './notification.state';
import {NotificationLevel} from '@birco/rainmesh-api';

export const selectNotificationState = createFeatureSelector<NotificationState>(FEATURE_NAME);

export const selectFilteredNotificationsWithCurrentPage = createSelector(
  selectNotificationState,
  (state) => {
    if (state.filter?.page === null
      || state.filter?.page === undefined
      || !state.pages[state.filter!!.page!!]) {
      return [];
    }

    return state.pages[state.filter!!.page!!]
      .map((id) => state.entities[id]) ?? []
  }
);

export const selectIsNotificationsLoading = createSelector(
  selectNotificationState,
  (state) => state.isLoading
);

export const selectNotificationsUnreadCount = createSelector(
  selectNotificationState,
  (state) => state.unreadCount
);

export const selectNotificationsTotalCount = createSelector(
  selectNotificationState,
  (state) => state.totalCount
);

export const selectNotificationFilter = createSelector(
  selectNotificationState,
  (state) => state.filter
);

export const selectUnreadErrorNotifications = createSelector(
  selectNotificationState,
  (state) => {
    return Object.values(state.entities).filter((notification) =>
      notification.level === NotificationLevel.ERROR &&
      !notification.readAt
    );
  }
);

export const selectLatestNotifications = createSelector(
  selectNotificationState,
  (state) => Object.values(state.entities)
    .sort((a, b) => new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime())
    .slice(0, 10)
);
